// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"b5961e3a","outerContainer":"_2c4f699e","secondaryToolbar":"c7bff9f4","doorHangerRight":"_53a99b19","toolbarContainer":"_10ab95c5","toolbarViewerMiddle":"_8b606e71","progressBar":"_087001b3","back-to-application":"c0f2e227","root":"f873ddd2","root--bottomLine":"_7b53afca","heading":"ad1e0d6a","sendMessage":"_37bb1b43","sendMessage__text":"a64809df"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/CollapsedSendMessageItem/styles.styl
// module id = 5192
// module chunks = 39